<template>
  <div class="wrapper">
    <div class="title">FASTGO快件承运条款</div>
    <div class="container">
      基本条款 <br>
      <br>
      寄件人：指在所在地国家委托FASTGO(速派）寄运物品进境中国（大陆）的个人或单位。<br>
      承运人：指FASTGO(速派）,负责物品的运输及淸关。<br>
      收件人：指在中国境内收取寄件人委托承运人所寄送包裹的个人或单位<br>
      1、寄件人委托承运人寄往各地之文件、货物、包裹及运送有关之物品，悉依本承运条款办理。寄件人委托前请先详细阅读本条款，全部了解后再填写快递单办理一切承运手续，一经填写即当作接受本条款内容。<br>
      2.相关法律、法规禁止寄送的物品，承运人不予收寄。包括但不限于：有价票证、禁寄的刊物、文物、金银制品、护照、私人证件、批文、现金、动物、植物、药物、毒品、仿制物品、有腐蚀性或放射性等危险、易燃易爆品及一切有关法律禁止邮寄的物品。寄件人应确保托寄物不属于禁寄物品。详情请参考官网“包装指南和禁寄物品"https://www.fastgo.com.au/<br>
      3.每个包裹单边长度超过40CM,起计费重量的计算公式为：体积重量=长X宽X高/5000。以上计算公式中，长、宽、高的单位为厘米。<br>
      4.当寄件人将物品交付给承运人时，承运人有权力对所收取的运送物件包裏打开并查验。国际包裹的海关通关规定寄件人必通提交海关通关所所属的文件，寄件人应确保所有有关物品的声明和信息都是真实的，和正确的。<br>
      5.在海关淸关过程中，或由于寄件人/收件人未能提供正确的文件、资料，或未能取得必要的许可证或批文，因而产生的海关罚款、储存费用和/或其它费用均由收件人负担，同时还须缴纳相应的附加费和税款。寄件人应当对收件人未付上述费用承担赉任。寄件人应当了解错误和欺诈的陈述或申报将可能受到民事和刑事处罚，包括对货品的没收、拍卖、销毀、迟运等。<br>
      6.总价值超过人民币1000.00元以上的包裹不能收寄：保健品、洗护用品包裹毛重不超过3.5公斤；化妆品包包裹不超过1公斤；如申报价值低于市场价请提供发票。旧物品不能收寄。或承运人与寄件人另行商定包裏的货值、重量限制，及附件条軟。
      保价条款<br>
      1.保价费率为申明价值的3%,保价须随快递面单附上发票原件，保价的货品、金额必须与发票信息一致。<br>
      2.如没有保价，则每票丢件理赔标准为：提供购物发票，按照发累面額理赔，但最高理赔不超过200.00元所在地货市；未能提供购物发票，则按照毎公斤20.00元所在地货币理赔，但最高理赔不超过200.00元所在地货币。<br>
      3.保价覆盖的递送范因并不涵盖从代收点/取件点到FASTGO仓库这段距离，只涵盖从FASTGO快递仓库到指定目的地的范围。<br>
      4.由于所在国海关开箱查验异致包装不严实而造成的后续运输破损，不在保价范畴，理赔参照第2条执行。<br>
      5.破损的主张必须提供快递派件员的签字证明与照片，内件丢失必须在快递派件员见证下清点货物并得到快递派件员的签字认可。物品的包装必须符合“FASTGOT快递包装指南”，详情请参考官网“包装指南和禁寄物品”https://www.fastgo.com.au/,其破损理赔要求才可以得到主张。<br>
      6.婴儿奶粉破损的责任
      婴儿奶粉必须按FASTGO速派的包装要求进行包装，对于其它不适规定包装的破损，FASTGO速派没有赔偿责任。婴儿奶粉如果在承运过程中出现损坏，如发生变型憋罐雄但不影响食用的，不给以描偿。如果发生泄露或爆管，对于可瑞康、爱他美、贝拉米、A2的铁罐装以外的婴儿奶粉，不予以赔偿。对于可瑞康、爱他美、见拉米、A2的铁罐装奶粉，按发票金额给予赔偿。1)需提供发票原件，如没有发票原件，按FASTGO认定的市场价格给与赔偿或进行实物赔付。2)其它条款参照前述条款执行。免责条款对托运货件的毁损，不论本公司是否知悉或应知悉可能发生该毁损，不论是直接、间接、特殊或衍生的损失，包括但不限于收入或利润损失，本公司对超过本“承运条款”、我司快件赔偿责任（详情参考官网“快件赔偿”https://www.fastgo.com.au/),以及相关法律法规规定的限度不负责任。对本公司无法控制之事件所造成之损失、损毁或延误，本公司不负任何责任。<br>
      <br>
      本服务条款解释权归FastGo速派快递公司所有。<br>

    </div>
  </div>

</template>

<script>
export default {
  name: "termsOfCarriage"
}
</script>

<style scoped>
.container {
  text-align: left;
  padding: 42px;
  line-height: 26px;
  font-size: 16px;
  color: rgb(102, 102, 102);
}
</style>



// WEBPACK FOOTER //
// src/view/PageService/components/termsOfCarriage.vue